import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

// get array of strings, join it with delimiter, for example coma, and show result in textarea
// value to set in control: split value from textarea by delimiter and set string array as value to control
@UntilDestroy()
@Component({
    selector: 'bazis-input-text-array',
    templateUrl: './input-text-array.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputTextArrayComponent extends BazisControlValueAccessor {
    @Input() delimiter: string = ', ';

    @Input() rows: number = 1;

    @Input() minlength: number = null;

    @Input() maxlength: number = null;

    field = new FormControl('');

    valueChanges$ = this.field.valueChanges.pipe(
        tap((value) => {
            this.onChange(
                value
                    .split(this.delimiter.trim())
                    .map((v) => v.trim())
                    .filter((v) => !!v),
            );
        }),
    );

    public setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.field.disable();
        } else {
            this.field.enable();
        }
    }

    public writeValue(value: any): void {
        this.field.setValue(value ? value.join(this.delimiter) : '', { emitEvent: false });
    }
}
